module.exports = {};



//////////////////
// WEBPACK FOOTER
// ./~/diffusion/~/core-js/internals/hidden-keys.js
// module id = 246
// module chunks = 1